// extracted by mini-css-extract-plugin
export default {"Main":"OptionColor_Main__Mn0KE","As":"OptionColor_As__ShvTm","AsTarget":"OptionColor_AsTarget__eU6bX","Text":"OptionColor_Text__Mex33"};